import { useContext, useState } from "react";
import { Box, Button, IconButton, Stack, Tab, Tabs, Typography } from "@mui/material";
import { getAmenitiesIcon, convertTo12HourFormat } from "../../utility/helper";
import AccordionExpandIcon from "../../ui/Accordion";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PDFsContainerComponent from "../pdf-container-component/hoa-pool-access-form-pdf-container";
import React from "react";
import { checkVisibility } from "../../utility/data-configurator-helper";
import datastore from "../../store/hoa-datastore";

const AmenityDetailsHeader = ({ handleClose }: any) => {
	return (
		<Stack
			direction="row"
			position="sticky"
			zIndex={9999}
			top={0}
			sx={{ background: "#FFFFFF" }}
			justifyContent="space-between"
			alignItems="center"
			pl="24px"
			pr="24px"
			height={72}
			borderBottom="1px solid #E8E8E8"
		>
			<Box display="flex" alignItems="center">
				<Typography fontSize={20} fontWeight={500} color="#2F2F2F">
					Amenity Details
				</Typography>
			</Box>
			<Box>
				<IconButton onClick={handleClose}>
					<CloseOutlinedIcon sx={{ color: "#2F2F2F" }} />
				</IconButton>
			</Box>
		</Stack>
	);
};

const Availability = ({ location }: any) => {
	const isTimeFormat = (value: string) => {
		const timeRegex = /^\d{1,2}:\d{2}$/;

		return timeRegex.test(value);
	};
	return (
		<Box>
			<Typography fontSize={16} fontWeight={500} color={"#3E3E3E"}>
				Availability
			</Typography>
			{location?.availability.map((schedule: any, index: number) => (
				<Stack key={index} width={274} direction="row" justifyContent="space-between" m={2}>
					<Typography fontSize={16} color="#303030">
						{schedule.day}
					</Typography>
					<Stack direction="column" gap="16px" alignItems="flex-end">
						{schedule.times.map((time: any, timeIndex: number) => (
							<Box key={timeIndex}>
								<Typography fontSize={16} color="#303030">
									{`${
										time.from
											? isTimeFormat(time.from)
												? convertTo12HourFormat(time.from)
												: time.from
											: "N/A"
									} - 
					${time.to ? (isTimeFormat(time.to) ? convertTo12HourFormat(time.to) : time.to) : "N/A"}`}
								</Typography>
							</Box>
						))}
					</Stack>
				</Stack>
			))}
		</Box>
	);
};

const PaymentMethod = ({ location }: any) => {
	return (
		<Box>
			<Typography fontSize={18} color={"#3E3E3E"} fontWeight={500}>
				Payment Method
			</Typography>
			<Stack direction={"row"} flexWrap={"wrap"} gap={"16px"} mt={1}>
				{location?.paymentMethod?.length ? (
					location?.paymentMethod.map((method: any, index: number) => (
						<Button
							key={index}
							style={{
								borderColor: "#C5C5C5",
								color: "#5B5B5B",
								background: "#F2F2F2",
								width: "124px",
								height: "36px",
							}}
							variant="outlined"
						>
							{method}
						</Button>
					))
				) : (
					<Box mt={2}>
						<Typography fontSize={14} color={"#303030"}>
							N/A
						</Typography>
					</Box>
				)}
			</Stack>
		</Box>
	);
};

const AmenitiesDocument = ({ folderType, documents, title }: any) => {
	return (
		<Box>
			{folderType === "rulesAndRegulationDocuments" ? (
				<Typography fontSize={14} color={"#787878"} fontWeight={500}>
					{title}
				</Typography>
			) : (
				<Typography fontSize={18} color={"#3E3E3E"} fontWeight={500}>
					{title}
				</Typography>
			)}
			<Stack direction={"column"}>
				{documents?.length ? (
					documents.map((file: any, index: number) => (
						<PDFsContainerComponent
							view={"view"}
							key={index}
							file={file}
							path="hoa"
							folder={folderType}
						/>
					))
				) : (
					<Box mt={2}>
						<Typography fontSize={14} color={"#303030"}>
							N/A
						</Typography>
					</Box>
				)}
			</Stack>
		</Box>
	);
};

const PhotoGalleryComponent = ({ photos }: any) => {
	const [tabIndex, setTabIndex] = useState(0);

	return (
		<div>
			<span className="text-3E3E3E-18px">Photos</span>
			{photos && photos[tabIndex] ? (
				<>
					<Stack direction={"column"} style={{ marginTop: "24px" }}>
						<img className="photo-container-amenities-new" src={photos[tabIndex].url} />
					</Stack>
					<Stack style={{ maxWidth: "543" }} direction={"row"}>
						<Tabs
							TabIndicatorProps={{
								style: {
									display: "none",
								},
							}}
							variant="scrollable"
							scrollButtons
							allowScrollButtonsMobile
							value={tabIndex}
							onChange={(event, value) => {
								setTabIndex(value);
							}}
						>
							{photos.map((value: any, index: number) => {
								return (
									<Tab
										key={index}
										value={index}
										label={
											<img
												src={value.url}
												className={
													index === tabIndex
														? "small-image-container active"
														: "small-image-container"
												}
											/>
										}
									/>
								);
							})}
						</Tabs>
					</Stack>
				</>
			) : (
				<Box mt={2}>
					<Typography fontSize={14} color={"#303030"}>
						N/A
					</Typography>
				</Box>
			)}
		</div>
	);
};

const AmenitiesDetails: React.FC<{ details: any; handleClose: any; getAmenityTypeText: any }> = ({
	details,
	handleClose,
	getAmenityTypeText,
}) => {
	const [expanded, setExpanded] = useState<number | false>(false);

	const handleAccordionChange =
		(panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
			setExpanded(isExpanded ? panel : false);
		};

	const accessInformationFindById = (id: string) => {
		let result = "";
		if (details?.accessInformation?.length) {
			result = details.accessInformation.find((info: any) => info.id === id)?.name || "";
		}
		return result;
	};

	const isAmenityVisible = (type: string) => {
		if (Object.keys(datastore.selectedConfiguration).length === 0) {
			return true;
		}

		const dbConfig =
			datastore.selectedConfiguration["Amenities"]["New Available Amenities"][
				"Show the added new available amenities"
			]["Locations"];
		return checkVisibility(dbConfig, type);
	};
	return (
		<Box sx={{ width: "623px", wordBreak: "break-all", overflowY: "scroll" }}>
			<AmenityDetailsHeader handleClose={handleClose} />
			<Box
				p={"24px"}
				display={"flex"}
				gap={"16px"}
				alignItems={"center"}
				borderBottom={"1px solid #E8E8E8"}
			>
				{React.createElement(getAmenitiesIcon(details?.amenityType), {
					color: "primary",
				})}
				<Typography style={{ color: "#3E3E3E", fontSize: "18px", fontWeight: "500" }}>
					{details?.amenityType === "Beache Access"
						? "Beach Access"
						: details?.amenityType}
				</Typography>
			</Box>
			<Box p={3}>
				<span className="text-3E3E3E-18px">Locations</span>
				<Stack mt={2} gap={3}>
					{details?.locations?.length > 0 &&
						details.locations.map((location: any, index: number) => {
							return (
								<AccordionExpandIcon
									expanded={expanded}
									handleAccordionChange={handleAccordionChange}
									index={index}
									title={details?.amenityType === 'Beache Access' ? `Beach Access ${index+1}` : `${details?.amenityType} ${index+1}`}
								>
									<Stack gap={2}>
									{isAmenityVisible("Name") && (
											<Stack direction={"column"}>
												<Typography
													fontSize={14}
													fontWeight={500}
													color={"#787878"}
												>
													Amenity Name
												</Typography>
												<Typography fontSize={14} color={"#3576E5"}>
													{location?.amenityName || "N/A"}
												</Typography>
											</Stack>
										)}
										{isAmenityVisible("Address") && (
											<Stack direction={"column"}>
												<Typography
													fontSize={14}
													fontWeight={500}
													color={"#787878"}
												>
													Amenity Address
												</Typography>
												<Typography fontSize={14} color={"#3576E5"}>
													{location?.address || "N/A"}
												</Typography>
											</Stack>
										)}
										{isAmenityVisible("Google Coordinates") && (
											<Stack direction={"column"}>
												<Typography
													fontSize={14}
													fontWeight={500}
													color={"#787878"}
												>
													Google Coordinates
												</Typography>
												<Typography fontSize={14} color={"#303030"}>
													{location?.googleCoordinates || "N/A"}
												</Typography>
											</Stack>
										)}
										{isAmenityVisible("Amenity Access Name") && (
											<Stack direction={"column"}>
												<Typography
													fontSize={14}
													fontWeight={500}
													color={"#787878"}
												>
													Amenity Access Name
												</Typography>
												<Typography fontSize={14} color={"#303030"}>
													{location?.amenityAccessName?.name || "N/A"}
												</Typography>
											</Stack>
										)}
										{isAmenityVisible("Availability") && (
											<Availability location={location} />
										)}
										{isAmenityVisible("Amenity Photos") && (
											<Box>
												<PhotoGalleryComponent
													photos={location?.amenityPhotos || []}
												/>
											</Box>
										)}
										{isAmenityVisible("Additional Amenities Documents") && (
											<AmenitiesDocument
												folderType={"additionalAmenitiesDocument"}
												title={"Additional Documents"}
												documents={location?.additionalAmenitiesDocument}
											/>
										)}
										{isAmenityVisible("Payment Method") && (
											<PaymentMethod location={location} />
										)}
										{isAmenityVisible("Rules & Regulations") && (
											<Box>
												<Typography
													fontSize={18}
													color={"#3E3E3E"}
													fontWeight={500}
												>
													Rules & Regulations
												</Typography>
												<Typography mt={2} fontSize={14} color={"#5B5B5B"}>
													{location?.rulesAndRegulations || "N/A"}
												</Typography>
											</Box>
										)}
										{isAmenityVisible("Rules & Regulations Document") && (
											<AmenitiesDocument
												folderType={"rulesAndRegulationDocuments"}
												title={"Regulation Document"}
												documents={location?.rulesAndRegulationDocuments}
											/>
										)}
									</Stack>
								</AccordionExpandIcon>
							);
						})}
				</Stack>
			</Box>
		</Box>
	);
};

export default AmenitiesDetails;
